import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class IMOService {
  async fetch(page, pageSize) {
    const response = await ajaxService.get(
      `/imo?page=${page}&perPage=${pageSize}`
    );
    if (response.success) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async viewIMO(id) {
    const response = await ajaxService.get(`/imo/${id}`);
    if (response.success) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async addDetails(id) {
    const response = await ajaxService.get(`/imo/details/${id}`);
    if (response.success) {
      return response;
    }
  }
  async addIMO(data) {
    const response = await ajaxService.post(`/imo`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async updateIMO(id, data) {
    const response = await ajaxService.put(`/imo/`, id, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
}

const imoService = new IMOService();

export default imoService;
